import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OwlModule } from 'angular-owl-carousel';

import { SharedModule } from '../../shared/shared.module';

import { IndexComponent } from './index/index.component';
import { BlogCollectionComponent } from './blog-collection/blog-collection.component';
import { DealCollectionComponent } from './deal-collection/deal-collection.component';
import { ElectronicsCollectionComponent } from './electronics-collection/electronics-collection.component';
import { FurnitureCollectionComponent } from './furniture-collection/furniture-collection.component';
import { ClothingCollectionComponent } from './clothing-collection/clothing-collection.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ProductsCollectionComponent } from './products-collection/products-collection.component';

@NgModule({
	declarations: [
		IndexComponent,
		BlogCollectionComponent,
		DealCollectionComponent,
		ElectronicsCollectionComponent,
		FurnitureCollectionComponent,
		ClothingCollectionComponent,
  ProductsCollectionComponent
	],

	imports: [
		CommonModule,
		RouterModule,
		TranslateModule,
		NgbModule,
		OwlModule,
		SharedModule,
		ReactiveFormsModule
	]
})

export class HomeModule { }
